import { useEffect, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router";
import Embed from "../components/embed";
import InstructionsDialog from "../components/instructions_dialog";
import SpiderChart from "../components/spider_chart";
import Slider from "../components/slider";
import CHARACTERS from "../characters";
import { AXIS_KEYS, SLIDER_KEYS } from "../axes";
import t from "../locales";

export default function Analysis({ response, onAnswerChange, onFinish }) {
  const { characterKey } = useParams();
  const navigate = useNavigate();
  const [commits, setCommits] = useState(0);

  const character = CHARACTERS.find(({ key }) => key === characterKey);
  const [values, setValues] = useState(response.getAnswer(characterKey));

  useEffect(() => {
    setValues(response.getAnswer(characterKey));
    const id = response.subscribe([characterKey], () => {
      setValues(response.getAnswer(characterKey));
    });
    return () => response.unsubscribe(id);
  }, [response, characterKey]);

  if (!response.getAnswer("groupCode")) return <Navigate replace to="/" />;
  if (!character) return <Navigate replace to="/personages" />;

  const name = t(`characters.names.${character.key}`);
  const [titleBefore, titleAfter] = t("analysis.title").split("{{name}}");
  const isFirstCharacter = characterKey === CHARACTERS[0].key;

  function handleSubmit(event) {
    event.preventDefault();

    onFinish(character.key);
    navigate(isFirstCharacter ? `/analyse/${CHARACTERS[1].key}` : "/result");
  }

  return (
    <>
      <form className="card card--analysis" onSubmit={handleSubmit}>
        <title>{t("analysis.page-title")}</title>
        <div className="card__header">
          <h1 className="card__title">
            {titleBefore}
            <span className="card__name" data-character={character.key}>
              {name}
            </span>
            {titleAfter}
          </h1>
          <p className="card__description">{t("analysis.description")}</p>
        </div>

        <div className="card__body">
          <SpiderChart
            bounceOn={commits}
            layers={[
              {
                label: name,
                color: character.color,
                values: AXIS_KEYS.map((key) => values[key] / 100),
              },
            ]}
          />

          <div className="card__sliders">
            {SLIDER_KEYS.map((key) => (
              <Slider
                key={key}
                id={`slider-${key}`}
                label={t(`spider-chart.axes.${key}`)}
                value={values[key]}
                color={character.color}
                onChange={(value) =>
                  onAnswerChange(character.key, { ...values, [key]: value })
                }
                onCommit={() => setCommits((count) => count + 1)}
              />
            ))}
          </div>
        </div>

        <button className="button" type="submit">
          {t(isFirstCharacter ? "analysis.next" : "analysis.compare")}
        </button>
      </form>

      <Embed
        key={`embed-${character.key}`}
        url={character.embed}
        label={name}
        color={character.color}
      />

      <InstructionsDialog
        key={`instructions-${character.key}`}
        characterKey={character.key}
      />
    </>
  );
}
